import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import { templateSelector } from '../selectors'
import API_URL from 'utils/ApiUrl'
// import $ from 'jquery'
// import { stepperIncrease } from 'actions/view'
import { nanoid } from 'nanoid'
import { createOrUpdateSmsTemplate } from 'actions/sms'

export const selectTemplateType = payload => dispatch =>
  new Promise(resolve => {
    return resolve(
      dispatch({
        type: ActionType.Email.Templates.SELECT_TEMPLATE_TYPE,
        payload,
      }),
    )
  })

export const changeFieldValues =
  (payload, fieldType, field) => (dispatch, getState) => {
    const sectionSelected = getState().email.sectionSelected

    dispatch({
      type: ActionType.Email.Templates.CHANGE_FIELD_VALUES,
      payload,
      fieldType,
      field,
      sectionSelected,
    })
  }

export const saveFieldValues = fieldType => (dispatch, getState) => {
  const sectionSelected = getState().email.sectionSelected
  const fieldTypeValues = getState().email[fieldType]

  dispatch({
    type: ActionType.Email.Templates.SAVE_VALUES,
    sectionSelected,
    fieldType,
    fieldTypeValues,
  })
}

export const listTemplates = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({ type: ActionType.Email.Templates.LIST_REQUEST })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${API_URL}/email/template`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then(res =>
            res.json().then(data => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then(payload => {
            if (payload && payload.notOk) {
              dispatch({
                type: ActionType.Data.LIST_FAILURE,
                payload,
                entityType: 'template',
                non200: true,
              })
              reject(payload)
              return
            }

            dispatch({
              type: ActionType.Email.Templates.LIST_SUCCESS,
              payload,
            })
            resolve(payload)
          })
          .catch(error => {
            dispatch({
              type: ActionType.Data.LIST_FAILURE,
              payload: error,
              entityType: 'template',
            })
            reject(error)
          })
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const deleteTemplate = templateId => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: ActionType.Email.Templates.DELETE_REQUEST,
      payload: templateId,
    })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return (
          fetch(`${API_URL}/email/template/${templateId}`, {
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            // .then(res => res.text())
            // .then(that => {
            //   console.log(that)
            //   resolve()
            // })
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.Data.DELETE_FAILURE,
                  payload,
                  entityType: 'template',
                  notOk: true,
                })
                return
              }

              dispatch({
                type: ActionType.Email.Templates.DELETE_SUCCESS,
                payload: templateId,
              })
              resolve(payload)
            })
            .catch(error => {
              dispatch({
                type: ActionType.Data.DELETE_FAILURE,
                payload: error,
                entityType: 'template',
              })
              reject(error)
            })
        )
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const createTemplate = preMadeTemplate => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const template = preMadeTemplate || templateSelector(getState())

    dispatch({
      type: ActionType.Email.Templates.CREATE_REQUEST,
      payload: template,
    })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return (
          fetch(`${API_URL}/email/template`, {
            body: JSON.stringify(template), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            // .then(res => res.text())
            // .then(that => {
            //   console.log(that)
            //   resolve()
            // })
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.Data.CREATE_FAILURE,
                  payload,
                  entityType: 'template',
                  non200: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.Email.Templates.CREATE_SUCCESS,
                payload,
              })
              resolve(payload)
            })
            .catch(error => {
              dispatch({
                type: ActionType.Data.CREATE_FAILURE,
                payload: error,
                entityType: 'template',
              })
              reject(error)
            })
        )
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const updateTemplate = preMadeTemplate => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const template = preMadeTemplate || templateSelector(getState())

    dispatch({
      type: ActionType.Email.Templates.UPDATE_REQUEST,
      payload: template,
    })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${API_URL}/email/template/${template.id}`, {
          body: JSON.stringify(template), // must match 'Content-Type' header
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'PUT', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then(res =>
            res.json().then(data => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then(payload => {
            if (payload && payload.notOk) {
              dispatch({
                type: ActionType.Data.UPDATE_FAILURE,
                payload,
                entityType: 'template',
                non200: true,
              })
              reject(payload)
              return
            }

            dispatch({
              type: ActionType.Email.Templates.UPDATE_SUCCESS,
              payload,
            })
            resolve(payload)
          })
          .catch(error => {
            dispatch({
              type: ActionType.Data.UPDATE_FAILURE,
              payload: error,
              entityType: 'template',
            })
            reject(error)
          })
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const receiveTemplate = template => dispatch =>
  dispatch({
    type: ActionType.Email.Templates.RECEIVE_TEMPLATE,
    payload: template,
  })

export const changeTemplateID = payload => dispatch =>
  dispatch({
    type: ActionType.Email.Templates.CHANGE_TEMPLATE_ID,
    payload,
  })

export const handleTemplateNameChange = value => dispatch =>
  dispatch({
    type: ActionType.Email.Templates.HANDLE_TEMPLATE_NAME_CHANGE,
    payload: value,
  })

export const readTemplate = id => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({
      type: ActionType.Email.Templates.READ_REQUEST,
      payload: id,
    })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${API_URL}/email/template/${id}`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then(res =>
            res.json().then(data => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then(payload => {
            if (payload && payload.notOk) {
              dispatch({
                type: ActionType.Data.READ_FAILURE,
                payload,
                entityType: 'template',
                non200: true,
              })
              reject(payload)
              return
            }

            dispatch({
              type: ActionType.Email.Templates.READ_SUCCESS,
              payload,
            })
            resolve(payload)
          })
          .catch(error => {
            dispatch({
              type: ActionType.Data.READ_FAILURE,
              payload: error,
              entityType: 'template',
            })
            reject(error)
          })
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const readFooter = () => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({ type: ActionType.Email.Templates.READ_FOOTER_REQUEST })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${API_URL}/email/footer_display`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then(res =>
            res.json().then(data => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then(payload => {
            if (payload && payload.notOk) {
              dispatch({
                type: ActionType.Data.READ_FAILURE,
                payload,
                entityType: 'footer',
                non200: true,
              })
              reject(payload)
              return
            }

            dispatch({
              type: ActionType.Email.Templates.READ_FOOTER_SUCCESS,
              payload,
            })
            resolve(payload)
          })
          .catch(error => {
            dispatch({
              type: ActionType.Data.READ_FAILURE,
              payload: error,
              entityType: 'footer',
            })
            reject(error)
          })
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const selectEmailCard = payload => dispatch =>
  dispatch({ type: ActionType.Email.Templates.SELECT_EMAIL_CARD, payload })

export const selectTheme = payload => dispatch => {
  // TODO: change this
  // dispatch(stepperIncrease('task'))
  // dispatch(stepperIncrease('template'))
  dispatch({ type: ActionType.Email.Templates.SELECT_THEME, payload })
}

export const readThemeFromHtml = payload => dispatch => {
  dispatch({ type: ActionType.Email.Templates.READ_THEME_FROM_HTML, payload })
}

export const toggleSnippetsPanel = () => dispatch =>
  dispatch({ type: ActionType.Email.Templates.TOGGLE_SNIPPETS_PANEL })

export const pasteSnippet = (payload /* , idx = null */) => dispatch => {
  // const innerHtml =
  //   $('[data-role="editor"]') &&
  //   $('[data-role="editor"]').data &&
  //   $('[data-role="editor"]').data('kendoEditor') &&
  //   $('[data-role="editor"]').data('kendoEditor').paste &&
  //   $('[data-role="editor"]').data('kendoEditor').paste(tag)

  dispatch({
    type: ActionType.Email.Templates.PASTE_SNIPPET,
    payload,
    // payload: {
    //   // innerHtml,
    //   tag,
    //   // idx,
    // },
  })
}

export const toggleVariablesPanel = payload => dispatch =>
  dispatch({ type: ActionType.Email.Templates.TOGGLE_VARIABLES_PANEL, payload })

export const defaultValueChange = (defaultValue, value) => dispatch =>
  dispatch({
    type: ActionType.Email.Templates.DEFAULT_VALUE_CHANGE,
    payload: { defaultValue, value },
  })

export const paste = tag => (dispatch, getState) => {
  const sectionSelected = getState().email.sectionSelected
  // const innerHtml =
  //   $('[data-role="editor"]') &&
  //   $('[data-role="editor"]').data &&
  //   $('[data-role="editor"]').data('kendoEditor') &&
  //   $('[data-role="editor"]').data('kendoEditor').paste &&
  //   $('[data-role="editor"]').data('kendoEditor').paste(tag)

  dispatch({
    type: ActionType.Email.Templates.PASTE_TAG,
    payload: {
      // innerHtml,
      tag,
    },
    sectionSelected,
  })
}

export const emailEditorChange = payload => (dispatch, getState) => {
  const sectionSelected = getState().email.sectionSelected

  dispatch({
    type: ActionType.Email.Templates.EMAIL_EDITOR_CHANGE,
    payload,
    sectionSelected,
  })

  // dispatch({
  //   type: ActionType.Email.Templates.EMAIL_EDITOR_CHANGE,
  //   payload: {
  //     innerHtml: $('[data-role="editor"]').val(),
  //     innerText: e ? e.sender.body.innerText : '',
  //   },
  // })
}

export const handleSubjectChange = value => dispatch =>
  dispatch({
    type: ActionType.Email.Templates.HANDLE_SUBJECT_CHANGE,
    payload: value,
  })

export const saveTemplate =
  ({ type, body }) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      console.log('saveTemplate')
      const templateID = getState().email.templateID

      if (type === 'email') {
        if (templateID === 'new') {
          dispatch(createTemplate(body)).then(payload => resolve(payload))
        } else {
          dispatch(updateTemplate(body)).then(payload => resolve(payload))
        }
      } else {
        dispatch(createOrUpdateSmsTemplate(`${templateID}`)).then(payload =>
          resolve(payload),
        )
      }
    })

export const backButton = () => dispatch =>
  dispatch({ type: ActionType.Email.Templates.BACK_BUTTON })

export const codeEditorChange = payload => (dispatch, getState) => {
  const sectionSelected = getState().email.sectionSelected

  dispatch({
    type: ActionType.Email.Templates.CODE_EDITOR_CHANGE,
    payload,
    sectionSelected,
  })

  // dispatch({
  //   type: ActionType.Email.Templates.CODE_EDITOR_CHANGE,
  //   payload: { innerHtml: value },
  // })
}

export const clickCodeButton = () => dispatch =>
  dispatch({ type: ActionType.Email.Templates.CLICK_CODE_BUTTON })

export const clickBottomNavigation = (event, payload) => dispatch =>
  dispatch({
    type: ActionType.Email.Templates.CLICK_BOTTOM_NAVIGATION,
    payload,
  })

export const toggleBottomNav = () => dispatch =>
  dispatch({ type: ActionType.Email.Templates.TOGGLE_COLLAPSE })

export const setSections = payload => dispatch =>
  dispatch({ type: ActionType.Email.Templates.SET_SECTIONS, payload })

export const clickSection = payload => dispatch =>
  dispatch({ type: ActionType.Email.Templates.CLICK_SECTION, payload })

export const selectSection =
  (payload = null) =>
  (dispatch, getState) => {
    const sections = getState().email.sections
    const section = sections?.[payload]

    if (section?.editor === 'img-picker' && typeof section.value === 'string') {
      // TODO: put a data attribute like "changed width" on images
      // then read them here, like 'data-vast-changed-height' and for width.
      // Maybe also 'original'...
      // But only do this if the value is different from the original.

      const src = 'src='
      const srcStringIdx = section.value.indexOf(src)

      const altStr = 'alt='
      const altStringIdx = section.value.indexOf(altStr)

      if (srcStringIdx !== -1) {
        // console.log(srcStringIdx)
        const quoteChar = section.value[srcStringIdx + src.length]
        const restOfString = section.value.substring(srcStringIdx + src.length)
        const stringArr = restOfString.split(quoteChar)
        const url = stringArr[1]

        const quoteCharAlt = section.value[altStringIdx + altStr.length]
        const restOfStringAlt = section.value.substring(
          altStringIdx + altStr.length,
        )
        const stringArrAlt = restOfStringAlt.split(quoteCharAlt)
        const alt = stringArrAlt[1]

        if (url) {
          const dataVastDimensions = 'data-vast-reach-dimensions-in-px='
          const dataVastDimensionsIdx =
            section.value.indexOf(dataVastDimensions)
          if (dataVastDimensionsIdx !== -1) {
            const quoteCharDimensions =
              section.value[dataVastDimensionsIdx + dataVastDimensions.length]
            const restOfStringDimensions = section.value.substring(
              dataVastDimensionsIdx + dataVastDimensions.length,
            )
            const stringArrDimensions =
              restOfStringDimensions.split(quoteCharDimensions)
            const dimensions = stringArrDimensions[1]

            return dispatch({
              type: ActionType.Email.Templates.SELECT_SECTION,
              payload,
              section,
              image: {
                width: dimensions.split(' ')[0],
                height: dimensions.split(' ')[1],
                url,
                alt,
              },
            })
          }

          let img = new Image()

          img.onload = function () {
            const { height, width } = img

            dispatch({
              type: ActionType.Email.Templates.SELECT_SECTION,
              payload,
              section,
              image: {
                width,
                height,
                url,
                alt,
              },
            })
          }

          img.src = url
        }
        // console.log(section.value.substring(srcStringIdx))
      }
    } else {
      dispatch({
        type: ActionType.Email.Templates.SELECT_SECTION,
        payload,
        section,
      })
    }
  }

export const removeSection = payload => dispatch =>
  dispatch({ type: ActionType.Email.Templates.REMOVE_SECTION, payload })

export const setImage = () => (dispatch, getState) => {
  dispatch({
    type: ActionType.Email.Templates.SET_IMAGE,
  })
}

export function getImageSize(cdnUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = function () {
      const { width, height } = this
      resolve({ width, height })
    }
    img.onerror = function () {
      reject(new Error('Failed to load image'))
    }
    img.src = cdnUrl
  })
}

export const setImageUrl = (payload, label) => (dispatch, getState) => {
  getImageSize(payload).then(({ width, height }) => {
    const sectionSelected = getState().email.sectionSelected

    dispatch({
      type: ActionType.Email.Templates.SET_IMAGE_URL,
      payload,
      label,
      width,
      height,
      sectionSelected,
    })
  })
}

export const setImageUrlWrapper = () => (dispatch, getState) => {
  const { urlPlaceholder, altPlaceholder } = getState().email.image
  dispatch(setImageUrl(urlPlaceholder, altPlaceholder))
}

export const setBackground = payload => dispatch =>
  dispatch({ type: ActionType.Email.Templates.SET_BACKGROUND, payload })

export const setTextAlign = payload => dispatch =>
  dispatch({ type: ActionType.Email.Templates.SET_TEXT_ALIGN, payload })

export const setImageDimension = (type, value) => dispatch => {
  if (typeof value === 'string') {
    if (value.match(/^[0-9]*$/)) {
      if (type === 'width' && parseInt(value) > 600) {
        return dispatch({
          type: ActionType.Email.Templates.SET_IMAGE_DIMENSION,
          payload: { type, value: '600' },
        })
      }

      if (!value) {
        return dispatch({
          type: ActionType.Email.Templates.SET_IMAGE_DIMENSION,
          payload: { type, value: '0' },
        })
      }
    }
  }

  return dispatch({
    type: ActionType.Email.Templates.SET_IMAGE_DIMENSION,
    payload: { type, value },
  })
}

export const setImageSize = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const sectionSelected = getState().email.sectionSelected
    resolve(
      dispatch({
        type: ActionType.Email.Templates.SET_IMAGE_SIZE,
        sectionSelected,
      }),
    )
  })

export const setImageProp = payload => (dispatch, getState) => {
  return dispatch({ type: 'set-image-prop', payload })
}

export const set = () => (dispatch, getState) => {
  const value = getState().email.body.value

  if (value) {
    var doc = new DOMParser().parseFromString(value, 'text/html')
    // console.log(doc)
    // console.log(doc.body.innerHTML)

    const foregroundElement = doc?.getElementsByClassName?.('foreground')?.[0]
    const backgroundElement = doc?.getElementsByClassName?.('background')?.[0]

    dispatch(
      setBackground({
        foreground:
          foregroundElement?.style?.background ||
          foregroundElement?.style?.backgroundColor,
        background:
          backgroundElement?.style?.background ||
          backgroundElement?.style?.backgroundColor,
      }),
    )

    dispatch(
      setTextAlign(doc?.getElementsByTagName?.('table')?.[0]?.style?.textAlign),
    )

    const themeTags = doc.getElementsByClassName('vastreach-theme')

    if (
      themeTags &&
      themeTags[0] &&
      themeTags[0].attributes &&
      themeTags[0].attributes['data-vast-theme'] &&
      themeTags[0].attributes['data-vast-theme'].value
    ) {
      dispatch(
        readThemeFromHtml(themeTags[0].attributes['data-vast-theme'].value),
      )
    }

    const sectionsArray = Array.from(
      doc.getElementsByClassName('vastreach-sections'),
    )

    console.log(sectionsArray)

    const dataArr = sectionsArray.length
      ? sectionsArray.map((el, idx) => {
          const editor =
            el.attributes['data-vast-editor'] &&
            el.attributes['data-vast-editor'].value

          // if (editor === 'img-picker') {

          // }

          return {
            id: nanoid(),
            value: el.innerHTML && el.innerHTML.trim(),
            editor,
          }
        })
      : doc &&
        doc.body &&
        doc.body.innerHTML && [
          { id: nanoid(), value: doc.body.innerHTML, editor: 'wysiwyg' },
        ]

    dispatch(setSections(dataArr))
  }
}

export const toggleDefaultValuesModal = payload => (dispatch, getState) =>
  dispatch({
    type: ActionType.Email.Templates.TOGGLE_DEFAULT_VALUES_MODAL,
    payload,
    smsValue: getState()?.tasks?.addOrEdit?.sms?.value,
  })
